define(['backbone'], function (Backbone) {
    'use strict';

    var router = new Backbone.Router({});

    return router;
});
